import { type MouseEvent } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslations } from '@/i18n/use-translations.tsx';
import { CircularProgress } from '@mui/material';

interface ConfirmationModalProps {
  open: boolean;
  title: string;
  text: string;
  onConfirm: (event: MouseEvent<HTMLButtonElement>) => void;
  onCancel: (event: MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
  confirmLabel?: string;
}

const ConfirmationModal = ({
  open,
  text,
  onConfirm,
  onCancel,
  title,
  isLoading,
  confirmLabel,
}: ConfirmationModalProps) => {
  const t = useTranslations();

  return (
    <Dialog
      onClick={(e) => e.stopPropagation()}
      open={open}
      onClose={onCancel}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-text"
    >
      {title && <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="confirmation-dialog-text">{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" disabled={isLoading} onClick={(e) => onCancel(e)}>
          {t('common.cancel')}
        </Button>
        <Button variant="contained" disabled={isLoading} onClick={(e) => onConfirm(e)} autoFocus sx={{ m: '0.4rem' }}>
          {isLoading ? <CircularProgress size={24} color="inherit" /> : (confirmLabel ?? t('common.confirm'))}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
